/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Browser
 */
export interface Browser {
    /**
     * 
     * @type {string}
     * @memberof Browser
     */
    name?: string;
}

/**
 * Check if a given object implements the Browser interface.
 */
export function instanceOfBrowser(value: object): value is Browser {
    return true;
}

export function BrowserFromJSON(json: any): Browser {
    return BrowserFromJSONTyped(json, false);
}

export function BrowserFromJSONTyped(json: any, ignoreDiscriminator: boolean): Browser {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function BrowserToJSON(value?: Browser | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

